import { Link } from "react-router-dom";
import { Megaphone, ArrowRight } from "lucide-react";

export default function SignalWidget() {
  return (
    <div
      className="overflow-hidden rounded-xl border border-primary/20 bg-primary p-6 text-white"
      data-testid="signal-widget"
    >
      <div className="flex h-11 w-11 items-center justify-center rounded-lg bg-white/15">
        <Megaphone className="h-6 w-6" />
      </div>
      <h3 className="mt-4 font-display text-xl font-extrabold">
        Видяхте проблем в квартала?
      </h3>
      <p className="mt-2 text-sm leading-relaxed text-blue-100">
        Дупка на пътя, авария, замърсяване или опасен участък? Подайте сигнал и
        нашата редакция ще го провери.
      </p>
      <Link
        to="/izprati-signal"
        data-testid="signal-widget-btn"
        className="mt-5 inline-flex items-center gap-2 rounded-full bg-white px-4 py-2.5 text-sm font-bold text-primary transition-transform hover:translate-x-0.5"
      >
        Изпрати сигнал
        <ArrowRight className="h-4 w-4" />
      </Link>
    </div>
  );
}
